<mat-card class="horizinns-card property-search-filter-card more-blur white-blur">
    <mat-card-title>
        <h3>Property Filter</h3>
    </mat-card-title>
    <mat-card-content>
        <form [formGroup]="searchForm" (ngSubmit)="submit()" class="form">
            
            <div class="form-row row-2">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>City</mat-label>
                    <input matInput formControlName="city">
                </mat-form-field>

                <ng-container *ngIf="activeStates$ | async as activeStates">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="state">
                            <mat-option [value]="undefined">Any</mat-option>
                            <!-- <mat-option *ngFor="let state of states" [value]="state.code">{{state.name}}</mat-option> -->
                            <mat-option *ngFor="let state of activeStates" [value]="state.code">
                                {{ state.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </div>

            <div class="range-section">
                <div class="range-header">
                    <span class="range-label">Bedrooms</span>
                    <span class="range-value">
                        {{searchForm.get('minBedrooms')?.value || 1}} - {{searchForm.get('maxBedrooms')?.value || 10}}+
                    </span>
                </div>
                <mat-slider min="1" max="10" step="1" discrete showTickMarks>
                    <input matSliderStartThumb formControlName="minBedrooms">
                    <input matSliderEndThumb formControlName="maxBedrooms">
                </mat-slider>
            </div>

            <div class="range-section">
                <div class="range-header">
                    <span class="range-label">Bathrooms</span>
                    <span class="range-value">
                        {{searchForm.get('minBathrooms')?.value || 1}} - {{searchForm.get('maxBathrooms')?.value || 5}}+
                    </span>
                </div>
                <mat-slider min="1" max="5" step="0.5" discrete showTickMarks>
                    <input matSliderStartThumb formControlName="minBathrooms">
                    <input matSliderEndThumb formControlName="maxBathrooms">
                </mat-slider>
            </div>

            <div class="range-section">
                <div class="range-header">
                    <span class="range-label">Sleeps (Guests)</span>
                    <span class="range-value">
                        {{searchForm.get('minSleeps')?.value || 1}} - {{searchForm.get('maxSleeps')?.value || 16}}+
                    </span>
                </div>
                <mat-slider min="1" max="16" step="1" discrete showTickMarks>
                    <input matSliderStartThumb formControlName="minSleeps">
                    <input matSliderEndThumb formControlName="maxSleeps">
                </mat-slider>
            </div>

            <div class="full-width action-button-row">
                <button mat-flat-button class="metallic-text-btn" type="button" (click)="reset()">
                    Reset
                </button>
                <button mat-flat-button class="metallic-text-btn-green" type="submit">
                    Apply Filters
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
<!-- <mat-card class="property-search-filter-card">
    <mat-card-content>
        <form [formGroup]="searchForm" (ngSubmit)="submit()" class="form">
            
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>City</mat-label>
                    <input matInput formControlName="city">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="state">
                        <mat-option *ngFor="let state of states" [value]="state.code">{{state.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="range-label">Bedrooms</div>
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Min</mat-label>
                    <mat-select formControlName="minBedrooms">
                        <mat-option [value]="null">Any</mat-option>
                        <mat-option *ngFor="let n of [1,2,3,4,5,6]" [value]="n">{{n}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Max</mat-label>
                    <mat-select formControlName="maxBedrooms">
                        <mat-option [value]="null">Any</mat-option>
                        <mat-option *ngFor="let n of [1,2,3,4,5,6,10]" [value]="n">{{n === 10 ? '10+' : n}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="range-label">Bathrooms</div>
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Min</mat-label>
                    <mat-select formControlName="minBathrooms">
                        <mat-option [value]="null">Any</mat-option>
                        <mat-option *ngFor="let b of [1,1.5,2,2.5,3,4]" [value]="b">{{b}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Max</mat-label>
                    <mat-select formControlName="maxBathrooms">
                        <mat-option [value]="null">Any</mat-option>
                        <mat-option *ngFor="let b of [1,2,3,4,5]" [value]="b">{{b}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="range-label">Sleeps (Guests)</div>
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Min</mat-label>
                    <mat-select formControlName="minSleeps">
                        <mat-option [value]="null">Any</mat-option>
                        <mat-option *ngFor="let s of [1,2,4,6,8]" [value]="s">{{s}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Max</mat-label>
                    <mat-select formControlName="maxSleeps">
                        <mat-option [value]="null">Any</mat-option>
                        <mat-option *ngFor="let s of [2,4,6,8,12,16]" [value]="s">{{s === 16 ? '16+' : s}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="full-width layout-right">
                <button mat-raised-button color="warn" type="button" (click)="cancel()">
                    Cancel
                </button>
                <button mat-raised-button color="accent" type="submit">
                    Apply Filters
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card> -->